import * as React from 'react';

import { IInfrastructurePoi } from '../../../../types/infrastructure';
import { INFRASTRUCTURE_ICON_MAP } from '../../constants';
import * as styles from './styles.css';

export interface IInfrastructurePinProps {
  poi: IInfrastructurePoi;
}

/** Точка инфраструктуры района: круглый пин с иконкой типа; станции метро подкрашиваются цветом линии. */
export function InfrastructurePin({ poi }: IInfrastructurePinProps): React.JSX.Element {
  const Icon = INFRASTRUCTURE_ICON_MAP[poi.type];

  return (
    <div
      className={styles['pin']}
      data-poi-type={poi.type}
      data-testid="district-infrastructure-map-pin"
      style={poi.lineColor ? { backgroundColor: poi.lineColor } : undefined}
      title={poi.title}
    >
      <Icon color="icon-inverted-default" />
    </div>
  );
}
